import { render } from 'preact';
import { App } from './app';
import { loadRuntimeConfig } from './lib/runtime-config';
import { initTheme } from './lib/theme';
import './theme.css';

async function bootstrap() {
  initTheme();
  await loadRuntimeConfig();

  const root = document.getElementById('app');
  if (!root) {
    throw new Error('missing #app root element');
  }

  render(<App />, root);
}

bootstrap().catch((error) => {
  console.error('failed to bootstrap tkw-mobile', error);
  document.body.innerHTML =
    '<div style="padding:20px;font-family:sans-serif;color:#e53e3e">' +
    'Anwendung konnte nicht gestartet werden.</div>';
});
